module.exports = __webpack_public_path__ + "static/media/partner_6_logo.efe38b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner_6_logo.png
// module id = 558
// module chunks = 0